// extracted by mini-css-extract-plugin
module.exports = {"emptyWrapper":"CropCompareEmpty_emptyWrapper__2u1V1","subtitle":"CropCompareEmpty_subtitle__3Jnj0","openButton":"CropCompareEmpty_openButton__3Z0q1"};